

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ListingEventType {

  Created = 1,

  Activated = 2,

  Deactivated = 3,

  Approved = 4,

  Unapproved = 5,

  ApprovalRequested = 6,

  Archived = 7,

  UnArchived = 8,

  Transferred = 9,

  Other = 10,

  Change = 11,

}

export default ListingEventType;